import React from 'react'
import Sketch from 'react-p5'
import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

let strings = new LocalizedStrings({
    en:{
        title:"presence",
        text:"now",
        description:""
    },
    de: {
        title:"gegenwart",
        text:"jetzt",
        description:""
    }
});

class Now extends React.Component {
    constructor(props) {
        super(props)

        this.fontSize = 10
        this.alpha = 255
        this.timeToGo = 0
        this.duration = 1500
        this.alphaDecrease = 3

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    reset(p5) {
        p5.background(0)
        this.fontSize = window.innerWidth / 5

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.reset(p5)
    }

    shout() {
        this.alpha = 255
        this.timeToGo = this.duration
    }

    draw(p5) {
        p5.background(0)

        if (this.timeToGo <= 0) {
            this.shout()
        }
        else {
            this.alpha -= this.alphaDecrease
            this.timeToGo -= p5.deltaTime
        }

        p5.textSize(this.fontSize)
        p5.fill(255, 255, 255, this.alpha)
        p5.textAlign(p5.CENTER, p5.CENTER)
        p5.text(strings.text, window.innerWidth/2, window.innerHeight/2)
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
Now.contextType = LanguageContext

export default Now
